export class StateEvent {
  constructor(private key: string, private value: any) {
  }

  public getKey(): string {
    return this.key;
  }

  public getValue(): any {
    return this.value;
  }

  public passesFilter(filter: string): boolean {
    return this.key.includes(filter);
  }
}
